import { span } from "./van-tags";

/**
 * @param {Object} cfg
 * @param {boolean} [cfg.flashing]
 * @param {boolean} [cfg.hidden]
 * @param {string} cfg.id
 * @param {EventListener} [cfg.onclick]
 * @param {1|2|3|4|5|6|7} [cfg.size] // lower is larger
 */
export function materialSymbol(cfg) {
	let iconClassList = "icon";
	switch (cfg.size) {
		case 1: // 3 rem
		case 2: // 2.5 rem
			iconClassList += " is-large";
			break;
		case 3: // 2 rem
		case 4: // 1.5 rem
			break;
		case 5: // 1.25 rem
			iconClassList += " is-medium";
			break;
		case 6: // 1 rem
		case 7: // 0.75 rem
			iconClassList += " is-small";
	}
	if (cfg.hidden) iconClassList += " is-hidden";

	let symbolClassList = `material-symbols-sharp is-size-${cfg.size}`;
	if (cfg.onclick) symbolClassList += " is-clickable";
	if (cfg.flashing) symbolClassList += " flashing";

	const onclick = cfg.onclick ? cfg.onclick : null;
	return span(
		{ class: iconClassList },
		span({ class: symbolClassList, onclick }, cfg.id),
	);
}
